import React, { ReactNode } from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import styles from "./ModalStyles.module.scss";

interface IModalBodyProps {
    children?: ReactNode;
    className?: string;
}

const ModalBody: React.FC<IModalBodyProps> = ({ children, className }) => {
    return (
        <div className={classNames(styles.modalBody, className)}>
            {children}
        </div>
    );
};

ModalBody.defaultProps = {
    className: "",
};

export default ModalBody;
